import classNames from "classnames";

import { Link, useLocation } from "react-router-dom";
import styles from "../style.module.scss";
import { useEffect, useState } from "react";
import { routeConstant } from "shared/routes/routeConstant";
import { useSelector } from "react-redux";
import { roundNum } from "shared/utils/helper";

const NavItem = ({ title, Icon, path, subPaths }: SideBarItemPathType) => {
  const {
    theme: { theme },
    archive: { count },
    breadcrumb: { prePath },
  } = useSelector((state: any) => state?.root);
  const location = useLocation();
  const [active, setActive] = useState<boolean>(false);

  useEffect(() => {
    if (
      (location.pathname === routeConstant.evaluationRecord.path ||
        location.pathname === routeConstant.archiveEvaluationRecord.path) &&
      subPaths
    ) {
      setActive(true);
    } else if (path === location.pathname) {
      setActive(true);
    } else if (
      location.pathname ===
      routeConstant.evaluationRecordDetail.path.replace(
        ":id",
        location.pathname.split("/")?.[3]
      )
    ) {
      if (
        (prePath === routeConstant.evaluationRecord.path ||
          prePath === routeConstant.archiveEvaluationRecord.path) &&
        subPaths
      ) {
        setActive(true);
      } else if (prePath === path) {
        setActive(true);
      } else {
        setActive(false);
      }
    } else if (
      location.pathname ===
      routeConstant.cgpEvaluationRecordDetail.path.replace(
        ":id",
        location.pathname.split("/")?.[3]
      )
    ) {
      if (prePath === path) {
        setActive(true);
      } else {
        setActive(false);
      }
    } else if (
      location.pathname ===
      routeConstant.continueDraftEvaluation.path.replace(
        ":id",
        location.pathname.split("/")?.[3]
      )
    ) {
      if (prePath === path) {
        setActive(true);
      } else {
        setActive(false);
      }
    } else {
      setActive(false);
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <>
      <Link
        className={classNames(
          theme === "dark" ? styles.darkNavIcon : styles.lightNavIcon,
          active ? styles.activeNavItemContainer : styles.navItemContainer,
          "w-full"
        )}
        to={path ? path : ""}
      >
        {Icon ? (
          <img src={Icon} alt="" className={classNames(styles.icon)} />
        ) : null}

        <label className={classNames(styles.heading)} role="button">
          {title}
        </label>
        {title === routeConstant.draftEvaluation.title &&
          count?.draftCount > 0 && (
            <div className={classNames(styles.badge)}>
              {roundNum(String(count?.draftCount), 1)}
            </div>
          )}
        {title === routeConstant.flagEvaluation.title &&
          count?.flaggedCount > 0 && (
            <div className={classNames(styles.badge)}>
              {roundNum(String(count?.flaggedCount), 1)}
            </div>
          )}
        {title === routeConstant.cgpEvaluation.title && count?.cgpCount > 0 && (
          <div className={classNames(styles.badge)}>
            {roundNum(String(count?.cgpCount), 1)}
          </div>
        )}
      </Link>
      <div
        className={classNames(styles.subPathsList, "w-full justify-between")}
      >
        {subPaths?.map((subPath: SideBarItemPathType, index: number) => {
          return <SubPath key={index} subPath={subPath} count={count} />;
        })}
      </div>
    </>
  );
};

const SubPath = ({ subPath, count }: any) => {
  const {
    theme: { theme },
    breadcrumb: { prePath },
  } = useSelector((state: any) => state?.root);
  const location = useLocation();
  const [isActivePath, setIsActivePath] = useState<boolean>(false);
  useEffect(() => {
    if (location.pathname === subPath?.path) {
      setIsActivePath(true);
    } else if (
      location.pathname ===
      routeConstant.evaluationRecordDetail.path.replace(
        ":id",
        location.pathname.split("/")?.[3]
      )
    ) {
      if (prePath === subPath?.path) {
        setIsActivePath(true);
      } else {
        setIsActivePath(false);
      }
    } else {
      setIsActivePath(false);
    }
    // eslint-disable-next-line
  }, [location.pathname]);
  return (
    <Link
      to={subPath.path ? subPath.path : ""}
      className={classNames(
        theme === "dark" ? styles.darkNavIcon : styles.lightNavIcon,
        isActivePath
          ? styles.activeSubNavItemContainer
          : styles.navItemContainer,
        "w-full justify-between"
      )}
    >
      <div className={classNames("flex items-center", styles.subPathContainer)}>
        <img src={subPath.Icon} alt="" className={classNames(styles.icon)} />
        <label className={classNames(styles.heading)} role="button">
          {subPath.title}
        </label>
        {subPath.title === routeConstant.evaluationRecord.title &&
          count?.totalCount > 0 && (
            <div className={classNames(styles.badge)}>
              {roundNum(String(count?.totalCount), 1)}
            </div>
          )}
      </div>
    </Link>
  );
};

export default NavItem;
